import { render } from "./GoHome.vue?vue&type=template&id=1520fa22&scoped=true&ts=true"
import script from "./GoHome.vue?vue&type=script&lang=ts"
export * from "./GoHome.vue?vue&type=script&lang=ts"

import "./GoHome.vue?vue&type=style&index=0&id=1520fa22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1520fa22"]])

export default __exports__